import React from 'react';
import {
  Text, Title, Container, ActionIcon, Group, rem, Space
} from '@mantine/core';
import { IconBrandWhatsapp, IconBrandYoutube, IconBrandInstagram } from '@tabler/icons-react';
import getWhatsappUrl from '@landing_academy/shared/utils/getWhatsappUrl';
import { Link } from 'gatsby';
import * as classes from './Footer.module.css';


const lnks = [
  { label: 'Alatin - latino biennio', link: 'https://alatin.it' },
  { label: 'Alatin Lyceum - latino triennio', link: 'https://lyceum-alatin.it/' },
  { label: 'Alex - analisi del testo', link: 'https://alextutor.it' },
  { label: 'Alex Triennio - analisi del testo triennio', link: 'https://alextutor.it' },
  { label: 'Itaca - grammatica italiana', link: 'https://itaca.academy' },
  { label: 'Praxis - greco', link: 'https://praxisacademy.it/' },
  { label: 'MathX - matematica per le superiori', link: 'https://mathx.it' },
];

const date = new Date();
const annoCorrente = date.getFullYear();

function Footers({ landingData, siteMetaData, guide, logo }) {
  const { tagLine } = landingData;
  const { youtube, whatsapp, instagram } = siteMetaData;

  return (
    <Container component="footer" className={classes.footer} fluid>
      <Container className={classes.inner} sx={{ border: '20px solid red !important' }}>
        <div className={classes.logo}>
          <div className={classes.logostyle}>
            {logo}
          </div>
          <Text size="sm" c="dimmed" className={classes.description}>
            {tagLine}
          </Text>
        </div>

        <div className={classes.groupsblock}>
          <Title mb="xs" order={4}>Scopri l'offerta didattica di Maieutical Labs:</Title>
          <div className={classes.links}>{
            lnks.map((link, index) => (
              <Text
                key={`link_${index + 1}_${link.link}`}
                className={classes.link}
                component="a"
                target="_blank"
                href={link.link}
              >
                {link.label}
              </Text>
            ))
          }
          </div>
          <Space h="md" />
          <Title mt="xl" mb="xs" order={4}>Manuali d'uso:</Title>
          <div className={classes.links}>{
            guide.map(({ stud, titolo }) => (
              <Text
                key={`guida_${stud}`}
                className={classes.link}
                component={Link}
                target="_blank"
                to={`/${stud}`}
              >
                {titolo}
              </Text>
            ))
          }
          </div>
        </div>
      </Container>
      <Container className={classes.afterFooter} fluid>
        <Container p={0}>
          <Text size="sm">
            © {annoCorrente} Maieutical Labs S.R.L.
          </Text>

          <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap">
            {whatsapp?.enabled && (
              <ActionIcon
                component="a"
                size="lg"
                color="gray"
                variant="subtle"
                target="_blank"
                href={getWhatsappUrl({ message: whatsapp.message, phone: whatsapp.phone })}
                title="Manda un messaggio Whatsapp a Maieutical Labs"
              >
                <IconBrandWhatsapp style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
              </ActionIcon>
            )}
            {youtube && (
              <ActionIcon
                component="a"
                size="lg"
                color="gray"
                variant="subtle"
                href={youtube}
                target="_blank"
                title="Visita il canale Youtube di Maieutical Labs"
              >
                <IconBrandYoutube style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
              </ActionIcon>
            )}
            {instagram && (
              <ActionIcon
                size="lg"
                component="a"
                color="gray"
                variant="subtle"
                href={instagram}
                target="_blank"
                title="Visita la pagina Instagram di Maieutical Labs"
              >
                <IconBrandInstagram style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
              </ActionIcon>
            )}
          </Group>
        </Container>
      </Container>
    </Container>
  );
}

export default Footers;
